<template>
  <div>
    <Header :right-sidebar="true" right-sidebar-title="Профсоюзы">
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="displayableUnionsFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="unionsFields"
            :items="unions"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item variant="success" to="/unions/create">
          Добавить профсоюз
          <template #icon>
            <b-icon icon="plus-square" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <b-table
        selectable
        select-mode="single"
        :busy="!loaded"
        :responsive="true"
        :items="paintedRows"
        :fields="pickedFields"
        @row-clicked="item => openUnion(item)"
        hover
        class="table-rounded"
        empty-text="Записей нет"
      >
        <template #cell(professionalGroups)="data">
          <router-link :to="`/unions/${data.item.id}/professional-groups`">
            Профгруппы
          </router-link>
        </template>
      </b-table>
    </Main>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import Main from "@/components/Layout/Main";
import { mapGetters } from "vuex";
import { displayableFields } from "@/components/Tables/defaultFields";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import { unionsFields } from "@/views/Unions/models/unionsFields";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    Main,
    SidebarItem,
    FiltersGroup,
    FieldsPicker,
    SidebarItemsGroup,
    Header
  },
  mixins: [pageTitleMixin],
  data() {
    let displayableUnionsFields = displayableFields(unionsFields);
    return {
      unionsFields,
      displayableUnionsFields,
      filteredItems: [],
      pickedFields: displayableUnionsFields
    };
  },
  computed: {
    ...mapGetters("unions", ["unions", "loaded"]),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    openUnion({ id }) {
      this.$router.push(`/unions/${id}`);
    }
  }
};
</script>
